<template>
  <div class="optionButtonWrapper" :class="{ selected, 'ru-locale': $i18n.locale === 'ru' }">
    <img
      v-if="(option as CustomButton)?.type === ElementType.Button"
      width="60"
      :src="`/img/icons/${option.key}.png`"
      alt=""
    />
    <img v-else-if="tokens[option?.key as Tokens]" width="60" :src="tokens[option.key as Tokens].toString()" alt="" />

    <h3 v-if="selected && isToken(option.key)" class="optionName">
      {{ Formatters.text.splitCamelCase(option.key) }}
    </h3>
    <h3 v-else-if="(option as CustomButton)?.type === ElementType.Button && selected" class="optionName">
      {{ $t((option as CustomButton)?.sectionLabel) || '' }}
    </h3>

    <el-skeleton v-if="isTokenOption(option) && option.apr" :loading="allAprStatus !== 'success'" animated>
      <template #template>
        <el-skeleton-item class="chevron-apr-skeleton" />
      </template>
      <template #default>
        <UIChevron v-if="option.apr > 0" :type="ChevronType.Apr">
          <span class="chevron-apr-label">{{ $t('appStatisticAPR') }}:</span>
          <span class="chevron-apr-value">
            {{ Formatters.number.renderString((f) => f.formatPercent((option as ITokenOptionItem).apr || 0)) }}%
          </span>
        </UIChevron>
      </template>
    </el-skeleton>
    <UIChevron v-else-if="(option as CustomButton)?.label" :type="ChevronType.Brown">
      <span class="chevron-apr-label">{{ $t((option as CustomButton).label) }}</span>
    </UIChevron>
  </div>
</template>

<script lang="ts" setup>
import type { Tokens } from '~/utils/constants';
import tokens from '~/public/img/tokens';
import { ChevronType, ElementType } from '~/utils/constants/ui';
import type { CustomButton, ITokenOptionItem } from '~/types/marketplace';
import { isToken, isTokenOption } from '~/types/typeguards';
import type { AsyncDataRequestStatus } from '#app';
import { Formatters } from '~/utils/formatters/formatters';

defineProps<{
  option: ITokenOptionItem | CustomButton;
  selected?: boolean;
}>();

const allAprStatus = inject<Ref<AsyncDataRequestStatus>>('allAprStatus');
</script>

<style scoped lang="scss">
.optionButtonWrapper {
  border-radius: 12px;
  border: 1px solid #1e353e;
  background: linear-gradient(0deg, #081b25, #081b25),
    linear-gradient(103.98deg, rgba(0, 0, 0, 0) 23.92%, rgba(0, 0, 0, 0.36) 63.2%, rgba(0, 0, 0, 0) 97.87%);
  box-shadow: 2px 4px 5px 0 rgba(0, 0, 0, 0.25);
  padding: 1em;
  min-width: 95px;
  height: 95px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-shrink: 0;
  position: relative;

  img {
    max-width: 60px;
    max-height: 60px;
  }

  &:hover:not(.selected) {
    background: radial-gradient(60px 60px at 50% 100%, rgba(0, 131, 173, 0.95) 0%, rgba(0, 131, 173, 0) 100%),
      radial-gradient(59.02px 71.08px at 84.01px 85.82px, #040f14 0%, #081b25 100%);
  }

  &:not(.selected) {
    cursor: pointer;
  }
}

.selected {
  width: 260px;
  background: linear-gradient(180deg, #0083ad 0%, #00354f 100%);
}

.optionName {
  white-space: nowrap;
  color: #fff;

  &::first-letter {
    text-transform: uppercase;
  }
}

.chevron {
  position: absolute;
  top: -12px;
  right: -10px;
}

.chevron-apr-skeleton {
  width: 88px;
  height: 24px;
  position: absolute;
  top: -12px;
  right: -10px;
}
</style>
